<template>
<div class="flex-container" id="ql-forgot-screen">
    <md-layout md-vertical-align="center">
        <md-layout md-flex="30" md-flex-offset="35" md-align="center">
            <h1>
                <img :src="require('../assets/img/cuelistBLACK.png')" alt="LOGO"/>
            </h1>
        </md-layout>
        <md-layout md-flex="100" md-align="center">
            <md-layout md-flex="30" md-offset="35" md-align="center" v-if="!sent">
                <form novalidate @submit.stop.prevent="submit">
                    <p>Please enter your email address to request a password reset.</p>
                    <md-input-container :class="{'md-input-invalid': emailError()}">
                        <label>Email</label>
                        <md-input v-model="email"></md-input>
                        <span class="md-error" v-if="emailError">{{message}}</span>
                    </md-input-container>
                    <div class="forgot-wrapper">
                        <md-button class="md-raised md-primary" @click="submit">RESET PASSWORD</md-button>
                        <md-button class="btn-troubleshoot" @click="back">Back to Login</md-button>
                    </div>
                </form>
            </md-layout>
            <md-layout md-flex="30" md-offset="35" md-align="center" v-else>
                <p>We just sent you and email to reset your password! Redirecting...</p>
            </md-layout>
        </md-layout>
    </md-layout>
    <core-footer/>
</div>
</template>

<script>
import firebase from 'firebase';

import CoreFooter from '@/components/core/footer';

const ForgotView = {
    name: 'ForgotView',
    data: function() {
        return {
            email: '',
            sent: false,
            message: ''
        };
    },
    methods: {
        isComplete() {
            return this.email !== '';
        },
        back() {
            this.$router.replace('/login');
        },
        submit() {
            this.message = '';
            firebase.auth().sendPasswordResetEmail(this.email).then(() => {
                this.sent = !this.sent;
                setTimeout(() => {
                    this.$router.replace('/login');
                }, 1000);
            }).catch((err) => {
                this.message = err.message;
            });
        },
        emailError() {
            return this.message !== '';
        }
    },
    components: {
        'core-footer': CoreFooter
    }
};
export default ForgotView;
</script>

<style lang="scss">
.forgot-wrapper {
    position: relative;
    .btn-troubleshoot {
        // font-size: 12px;
        position: absolute;
        float: right;
        text-transform: none;
        font-weight: 600;
        letter-spacing: 0.5px;
    }
}
</style>


// WEBPACK FOOTER //
// forgot.vue?10a09afe